import * as PageActions from './page.actions';
import * as ContactActions from './contact.actions';

export { PageActions, ContactActions };
